<template>
  <div class="expend-settings app-region blank-l-h blank-r-h">
    <a-row :gutter="64" type="flex">
      <a-col :span="24" :xl="6" class="divide">
        <div class="page-title">房源架构</div>
        <a-input placeholder="请输入关键词" v-model="tree.keyword" @change="filterKeyword(tree.data, 'tree.searchData', tree.keyword, tree.params.title, tree.params.children)"></a-input>
        <a-spin tip="加载中..." :spinning="tree.loading">
          <a-tree block-node :tree-data="tree.keyword ? tree.searchData : tree.data" :replaceFields="tree.params" @select="selectTreeNode" :selected-keys="tree.selectedKeys" :load-data="$houseTreeData"></a-tree>
        </a-spin>
      </a-col>
      <a-col :span="24" :xl="18">
        <div class="page-title">{{name}}（{{total}}）</div>
        <expend-settings-list :id="id" :community-id="communityId" @total="setTotal"></expend-settings-list>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import ExpendSettingsList from '@/views/community/expend_settings/List.vue';

  export default {
    name: 'ExpendSettings',
    data() {
      return {
        tree: {
          selectedKeys: [],
          keyword: null,
          loading: false,
          data: [],
          searchData: [],
          params: {
            children: 'children',
            title: 'name',
            key: '_id'
          }
        },
        id: null,
        communityId: null,
        name: null,
        total: null
      }
    },
    mounted () {
      this.initTreeData().then(() => {
        this.selectTreeNode([this.tree.data[0][this.tree.params.key]]);
      });
    },
    components: {
      ExpendSettingsList
    },
    methods: {
      setName() {
        let name = '全部';
        this.$depthSearchTree(node => {
          if (node[this.tree.params.key] === this.tree.selectedKeys[0]) {
            name = node[this.tree.params.title];
          }
        }, this.tree.data);
        this.name = name;
      },
      selectTreeNode(selectedKeys) {
        if (selectedKeys.length) {
          this.tree.selectedKeys = selectedKeys;
          this.$depthSearchTree(node => {
            if (node[this.tree.params.key] === selectedKeys[0]) {
              if (node.level === 0) {
                this.id = null;
                this.communityId = node.id;
              } else {
                this.id = node.id;
                this.communityId = node.communityId;
              }
            }
          }, this.tree.data);
          this.setName();
        }
      },
      setTotal(total) {
        this.total = total;
      },
      initTreeData() {
        this.tree.loading = true;
        return this.$houseTreeData([], [this.isPlatformRole ? 0 : 1, 3]).then(res => {
          this.tree.data = res;
          this.tree.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>
  
</style>